import { inject, Injectable } from '@angular/core';
import { delay, Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { MockService } from '@mock/mock.service';
import { IUserUiStateShared } from '@app/api/interfaces/user-ui-state-shared.interface';
import { MainViewMode } from '@app/core/enums/main-view-mode.enum';
import { ProjectsMockService } from '@mock/data-services/projects-mock.service';
import { testProjectId } from '@mock/data/projects-mock.data';
import { PageExpandedMode } from '@app/core/enums/page-expanded-mode.enum';
import { toLocalIsoDate } from '@app/shared/utils/date';

@Injectable({
  providedIn: 'root',
})
export class UserUiStateSharedMockService extends MockService {
  private projectsMockService = inject(ProjectsMockService);

  public get(): Observable<IApiResponse<IUserUiStateShared, object>> {
    return this.mockResponse('USER_UI_STATE_SHARED:get', {
      data: {
        viewMode: MainViewMode.LeakDetection,
        projectId: this.isMockDataGenerated() ? this.projectsMockService.resolveProjectId(1) : testProjectId,
        mapLegendCollapsed: true,
        mapShowNativeSearch: true,
        pageExpandedMode: PageExpandedMode.Base,
        mapShowCustomFilter: false,
        date: toLocalIsoDate(new Date('2026-01-23')),
        cellIdModeEnabled: false,
      },
      meta: {},
    }).pipe(delay(this.requestDelay));
  }

  public update(state: IUserUiStateShared): Observable<IApiResponse<IUserUiStateShared, object>> {
    return this.mockResponse('USER_UI_STATE_SHARED:update', {
      data: state,
      meta: {},
    }).pipe(delay(this.requestDelay));
  }
}
